import { TARIFF_SERVICE_NAME, TariffServiceProvider } from './tariff.service'
import { TARIFF_LOCATIONS_SERVICE_NAME, TariffLocationsServiceProvider } from './tariff.locations.service'
import { TARIFF_CONTEXT_MENU_SERVICE_NAME, TariffContextMenuServiceProvider } from './tariff.context-menu.service'

export const TARIFF_SERVICES_MODULE_NAME = 'simax.services.tariff'

const module = angular.module(TARIFF_SERVICES_MODULE_NAME, [])

module.provider(TARIFF_SERVICE_NAME, TariffServiceProvider)
module.provider(TARIFF_LOCATIONS_SERVICE_NAME, TariffLocationsServiceProvider)
module.provider(TARIFF_CONTEXT_MENU_SERVICE_NAME, TariffContextMenuServiceProvider)

